
const imageUrl = (title) => {
  return `/imgs/case/park/${title}.png`;
};

const data = {
  introduce: {
    img: imageUrl('introduce'),
    title: '四流合一',
    description: '建设综合电商平台+仓配一体化+供应链金融的综合信息化系统，打造物流、商流、信息流、资金流“四流合一”的全链全渠道的供应链服务能力，以供应链视角统领全局，致力于客户供应链效率的提升。',
    imgPadding: true
  },
  method: imageUrl('method'),
  value: [
    {
      title: '价值一',
      description: '每年可减少物流过程中汽柴油消耗1000多吨，货物库存周转率同比提高10%，包装物的回收利用率提高30%。',
      img: imageUrl('value1')
    },
    {
      title: '价值二',
      description: '是全国首个供应链+金融的物流园项目成功落地案例。',
      img: imageUrl('value2')
    },
    {
      title: '价值三',
      description: '成为物资集散、仓储、配送功能、为社会提供“一站式”商品流通服务的综合物流园。',
      img: imageUrl('value3')
    },
    {
      title: '价值四',
      description: '实现了传统模式向流程化、信息化管理的转变，以及年总交易量420万吨，交易额80亿元，容纳客户数约1000户的阶段性目标。',
      img: imageUrl('value4')
    }
  ]
};

export default data;


// WEBPACK FOOTER //
// ./src/routes/Case/config/park.js